import { useBreathingPractice } from '../model/useSos'
import styles from './SosPage.module.css'

export default function BreathingDialog({ onClose }: { onClose: () => void }) {
  const { phase, cycle, step, dialogRef, closePractice, cancelPractice, closeOnBackdrop } = useBreathingPractice(onClose)
  return (
    <dialog ref={dialogRef} className={styles.dialog} aria-label="Дыхательная практика" onCancel={cancelPractice} onClick={closeOnBackdrop}>
      <div className={styles.practice}>
        <button type="button" className={styles.close} onClick={closePractice} aria-label="Закрыть практику">×</button>
        <p className={styles.practiceKicker}>Дыхательная практика 4–4–6</p>
        <div key={step} className={`${styles.circle} ${styles[phase.id]}`} aria-hidden="true" />
        <p className={styles.phase} aria-live="polite">{phase.label}</p>
        <p className={styles.hint}>{phase.hint} · {phase.seconds} сек</p>
        <p className={styles.cycle}>Цикл {cycle}</p>
        <ol className={styles.steps}>
          <li>Вдох через нос — 4 секунды</li>
          <li>Мягкая пауза — 4 секунды</li>
          <li>Долгий выдох через рот — 6 секунд</li>
        </ol>
      </div>
    </dialog>
  )
}
